import { z } from 'zod';

import { Option } from '../../types/Option';

const list = ['unearthed', 'earthedPositive', 'earthedNegative', 'earthedMidpoint'] as const;

type DCEarthingConfiguration = (typeof list)[number];

const options = [
    { value: 'unearthed', label: 'Floating' },
    { value: 'earthedPositive', label: 'Positive grounded' },
    { value: 'earthedNegative', label: 'Negative grounded' },
    { value: 'earthedMidpoint', label: 'Midpoint grounded' },
] as Option<DCEarthingConfiguration>[];

const validator = z.array(z.enum(list)).default([]);

export const DCEarthingConfigurations = {
    validator,
    options,
};
